import { render, staticRenderFns } from "./subLocationBox.vue?vue&type=template&id=331427e5"
import script from "./subLocationBox.vue?vue&type=script&lang=js"
export * from "./subLocationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports